exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preparation-product-page .preparation-product-name a[data-v-0bccdec1] {\n  text-decoration: none;\n  color: #212529;\n}\n.preparation-product-page .preparation-product-name a[data-v-0bccdec1]:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}", ""]);

// exports
